const API_BASE_URL = 'https://api.labeldesign.ai';
const updateApprovalUrl = `${API_BASE_URL}/updateprojectstatus`;

// Form submission handler
document.addEventListener('DOMContentLoaded', function() {
  const requestChangeForm = document.querySelector('.form-request-change');
  
  if (!requestChangeForm) {
    console.error('Request-a-change form not found');
    return;
  }

  // Handle form submission - just update Firebase status
  requestChangeForm.addEventListener('submit', async function(e) {
    // Get form data
    const formData = new FormData(requestChangeForm);
    const bundleId = formData.get('contact[project]');

    // Only update Firebase if we have a bundleId
    if (bundleId) {
      try {
        // Update project status to "revisions_requested" (non-blocking)
        updateProjectStatus(bundleId, 'revisions_requested').then(response => {
          if (response.success) {
            console.log('Project status updated to revisions_requested');
          }
        }).catch(error => {
          console.error('Error updating project status:', error);
        });
      } catch (error) {
        console.error('Error updating project status:', error);
      }
    }

    // Let Shopify handle the form submission normally
    // Don't prevent default - let it submit naturally
  });
});

/**
 * Update project status via Firebase function (using updateProjectStatus)
 * @param {string} bundleId - The project bundle ID
 * @param {string} projectStatus - The new status (e.g., "revisions_requested")
 * @param {object} additionalData - Additional data to include
 * @returns {Promise<object>} Response from Firebase function
 */
async function updateProjectStatus(bundleId, projectStatus, additionalData = {}) {
  try {
    const response = await fetch(updateApprovalUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bundleId: bundleId,
        projectStatus: projectStatus,
        ...additionalData
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating project status:', error);
    throw error;
  }
}


